import { POST } from '@sisyphe/utils'

/**
 * @description 用户发送短信验证码
 */
export function sendSmsUsingPOST(
  params: SwaggerDTO.用户登录请求参数 & { loginMobile?: string }
): Promise<SwaggerDTO.ResponseResult<SwaggerDTO.XXFResponseResult>> {
  return POST('/enterprise-procurement-client/login/send', params)
}

/**
 * @description 用户登录
 */
export function loginUsingPOST(
  params: SwaggerDTO.用户登录请求参数
): Promise<SwaggerDTO.ResponseResult<SwaggerDTO.LoginResponseDTOReq>> {
  return POST('/enterprise-procurement-client/login/verify', params)
}
